export type BrandGroupModel = {
  agency_paginated?: boolean,
  brand_id: number,
  cache_key: number,
  debug_mode?: boolean,
  disable_agency_sharing?: boolean,
  full_access?: boolean,
  id: number,
  member_count?: number,
  title: string,
}

export type BrandGroupRequestOptions = {}

const state = {
  id: null,
  brand_id: undefined,
  title: '',
  full_access: false,
  agency_paginated: false,
  debug_mode: false,
  disable_agency_sharing: false,
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'title' },
]

export default state
